import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { regionais } from '../../../constants/region.constant';
import { especialidadesEAreasDeAtuacao } from '../../../models/index';
import { ProductService } from '../../../services/product-service/product.service';
import { FormControl, Validators } from '@angular/forms';

import { UtilService } from 'src/app/services/util-service/util.service';

@Component({
  selector: 'app-product-register',
  standalone: false,
  templateUrl: './product-register.html',
  styleUrl: './product-register.scss',
})
export class ProductRegister {
  public kit: any = {};
  public regions:any = regionais;
  public regionOptions = regionais.map((r: string) => ({ value: r, description: r }));
  public specialties:any = especialidadesEAreasDeAtuacao;
  loading:boolean = false;

  readonly dialogRef = inject(MatDialogRef<ProductRegister>);
  display: FormControl = new FormControl("", Validators.required);
  file_store: any = [];
  file_list: Array<string> = [];
  previewUrl: string | ArrayBuffer | null = null;
  isDragging = false;

  constructor(
  @Inject(ProductService) private productService: ProductService,
  @Inject(UtilService) private utilService: UtilService
  ) {
    this.kit = {
      titulo:'',
      subtitulo: '',
      imagem: '',
      descricao_resumo: '',
      descricao: '',
      especialidades_elegiveis: [],
      regioes_elegiveis: [],
      estoque: 0
    }
   }

    ngOnInit(): void {}

   ngOnDestroy(): void {}


  getSpecialtyDescriptions(values: string[]): string {
    if (!values?.length) return '';
    return values
      .map(v => this.specialties.find((s: any) => s.value === v)?.description || v)
      .join(', ');
  }

  getSpecialtyDescriptionsArray(values: string[]): string[] {
    if (!values?.length) return [];
    return values
      .map(v => this.specialties.find((s: any) => s.value === v)?.description || v)
      .filter(desc => desc); // Remove valores vazios
  }

   setValue(ev:any){
    return ev.target.value;
   }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer?.files.length) {
      this.handleFileInputChange(event.dataTransfer.files);
    }
  }

     handleFileInputChange(l: FileList): void {
        this.file_store = l;
        this.file_list = [];

        if (l.length) {
          const f = l[0];
          const countText = l.length > 1 ? ` (+${l.length - 1} files)` : "";
          this.display.patchValue(`${f.name}${countText}`);

          this.previewImage(f);
          for (let i = 0; i < l.length; i++) {
            this.file_list.push(l[i].name);
          }
        } else {
          this.display.patchValue("");
          this.previewUrl = null;
        }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload =  () => {
      this.previewUrl = reader.result;

    };
     reader.readAsDataURL(file)
  }

   async save(){
     this.loading = true;
       try {
        if (!this.file_store?.length) {
          throw new Error('Nenhum arquivo selecionado');
        }

        const file: File = this.file_store[0];
        const base64 = await this.utilService.convertFileToBase64(file);
        const payload = {
              ...this.kit,
              file: {
                base64: base64,
                filename: file.name,
                mimetype: file.type
              }
            };

        await this.productService.createKit(payload);
        this.kit.imagem = base64;
        this.loading = false;
      this.dialogRef.close(this.kit);
    } catch (error) {
      this.loading = false;
      console.error(error);
    }
   }

  goToProducts() {
    this.dialogRef.close();
  }

}
